import { render, staticRenderFns } from "./ContactOwnerUpdated.vue?vue&type=template&id=0a6a5230&scoped=true"
import script from "./ContactOwnerUpdated.vue?vue&type=script&lang=js"
export * from "./ContactOwnerUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a5230",
  null
  
)

export default component.exports